export function registerGlobalErrorHandlers() {
  const navigateToServerError = () => {
    window.location.href = "/Server-Error";
    
  };

  window.addEventListener("error", (event) => {
    console.error("Global error caught:", event.error || event.message);
    event.preventDefault();
    if (
      event?.message?.includes("Loading chunk") ||
      event?.error?.name === "ChunkLoadError"
    ) {
      console.warn(
        "ChunkLoadError detected, navigating to /Server-Error and clearing localStorage..."
      );
      event.preventDefault();
      navigateToServerError();
    } else {
      event.preventDefault();
      navigateToServerError();
    }
  });

  window.addEventListener("unhandledrejection", (event) => {
    console.error("Unhandled Promise rejection:", event.reason);
    event.preventDefault();
    navigateToServerError();
  });
}
